// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "screen and (max-width: 320px)";
var _4 = "wrapper-1WkM7";
var _5 = "wrapper_mobileFullScreen-RCzkg";
var _6 = "footer-J1vNf";
var _7 = "button-U8wmw";
var _8 = "button_cancel-2UyFc";
export { _1 as "__esModule", _2 as "mobile", _3 as "iphone5", _4 as "wrapper", _5 as "wrapper_mobileFullScreen", _6 as "footer", _7 as "button", _8 as "button_cancel" }
export default { "__esModule": _1, "mobile": _2, "iphone5": _3, "wrapper": _4, "wrapper_mobileFullScreen": _5, "footer": _6, "button": _7, "button_cancel": _8 }
